if (isBrowser) {
    $(document).ready(function (e) {
        if ($(window).width() <= 991) {

        } else if ($(window).width() <= 768) {

        }
    });
}